/* eslint-disable no-magic-numbers, @typescript-eslint/naming-convention -- mirrors @technology/web3d const enum SnapType */
export enum SnapType {
  FACE = 0,
  LINE = 1,
  POINT = 2,
  CENTER_LINE = 3,
  CENTER_POINT = 4,
  CONTROL_POINT = 5,
  MIDPOINT = 6,
  PERPENDICULAR_POINT = 7,
  INTERSECTION_POINT = 8,
}
